import React, { useEffect } from "react";
import { Card, Typography, Button } from "@material-tailwind/react";
import { useForm, FormProvider } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";

import FormInput from '../../../components/FormInput';
import {
    email_validation,
    name_validation,
} from '../../../utils/inputValidations'
import { RootState } from "../../../redux";
import { profileUpdateRequest } from "../../../redux/auth/actions";

interface ProfileFormData {
    name: string;
    email: string;
}

function DashboardProfile() {
    const dispatch = useDispatch();
    const { auth } = useSelector((state: RootState) => state.auth);

    const methods = useForm<ProfileFormData>({
        defaultValues: {
            name: auth?.user?.user?.first_name + " " + auth?.user?.user?.last_name,
            email: auth?.user?.user?.email
        }
    });

    useEffect(() => {
        console.log('auth', auth);
        methods.setValue("name", auth?.user?.user?.first_name + " " + auth?.user?.user?.last_name);
        methods.setValue("email", auth?.user?.user?.email || "");
    }, [auth]);

    const onSubmit = (data: ProfileFormData) => {
        console.log('Updated profile:', data);
        dispatch(profileUpdateRequest({
            first_name: data.name.split(" ")[0],
            last_name: data.name.split(" ")[1],
            email: data.email
        }));
    };

    return (
        <React.Fragment>
            <FormProvider {...methods}>
                <form
                    className="flex flex-col mt-4"
                    onSubmit={(e) => e.preventDefault()}
                    noValidate
                >
                    <Card className="p-6 mb-4">
                        <div className="flex justify-between items-center">
                            <Typography variant="h4" color="default" className="mb-6">
                                Profile Information
                            </Typography>
                            <Button
                                variant="solid"
                                color="info"
                                onClick={methods.handleSubmit(onSubmit)}
                            >
                                Save Changes
                            </Button>
                        </div>

                        <div className="space-y-6">
                            <FormInput {...name_validation} />
                            <FormInput {...email_validation} />
                        </div>
                    </Card>
                </form>
            </FormProvider>
        </React.Fragment>
    );
}

export default DashboardProfile;